<div class="d-flex" id="wrapper">
    <app-sidebar></app-sidebar>
    <div class="page-background" id="page-content-wrapper" style="width: 100%;">
        <!-- <app-header></app-header> -->
        <app-virtual></app-virtual>
        <div class="container-fluid" id="target">
            
            <div class="content">

                

                <!-- <div id="box" [ngClass]="[bntStyle]" style="transition: all 500ms cubic-bezier(0.25, 0.25, 0.75, 0.75) 0s;" class=""> demo thing is here </div> -->
                <app-breadcrumb></app-breadcrumb>
                <router-outlet></router-outlet>

            </div>
        </div>
        <footer>
            <ul class="footer-ul">
                <li>
                    <a>
                        KVKK
                    </a>
                </li>
                <li>
                    <a>
                        Gizlilik Politikası
                    </a>

                </li>
                <li>
                    <a href="https://www.perasis.com/" target="_blank">
                        <img src="assets/img/perasis-logo.svg">
                    </a>

                </li>
                <li>
                    <a>
                        Bilgi Edinme Hakkı
                    </a>

                </li>
                <li>
                    <a>
                        Site Kullanım Kuralları
                    </a>
                </li>
            </ul>

        </footer>
    </div>
</div>

<div class="loader-container" [style.display]="isVisibleAppLoading ? '' : 'none'">
    <img src="/assets/logo/logo-w.svg" />
    <div class="loader">
        <span></span>
        <span></span>
        <span></span>
    </div>
</div>

<app-modal [(isVisible)]="isVisibleCropModal" sizeClass="modal-xl" (onHidden)="onHiddenCropModal()">
    <app-crop-image [(fileEvent)]="imageChangedEvent" (onResult)="onResultImageCropped($event)"
        (onCancel)="onHiddenCropModal()"></app-crop-image>
</app-modal>